<template>
    
    <div class="authentication-wrapper authentication-cover">
      <!-- Logo -->
      
      <!-- /Logo -->
      <div class="authentication-inner row m-0">
        <!-- /Left Section -->
        <div class="d-none d-lg-flex col-lg-7 col-xl-8 align-items-center justify-content-center p-5 pb-2" style="background: url('../../assets/img/cover_login.webp'); background-size: cover; background-repeat:no-repeat">
          
          <img
            src="../../assets/img/cover_login.webp"
            class="authentication-image"
            alt="mask"
            data-app-light-img="illustrations/auth-cover-login-mask-light.png"
            data-app-dark-img="illustrations/auth-cover-login-mask-dark.png" />
        </div>
        <!-- /Left Section -->

        <!-- Login -->
        <div
          class="d-flex col-sm-12 col-lg-5 col-xl-4 align-items-center authentication-bg position-relative py-sm-5 px-4 py-4">
          <div class="w-px-400 mx-auto pt-5 pt-lg-0">
            <a  class="auth-cover-brand justify-content-center d-flex align-items-center gap-2 left-0 right-0">
                <span class="app-brand-logo demo"><img src="@/assets/logonsia.png" style="width: 200px;"/></span>
            </a>
            <h4 class="mb-2 text-center fw-semibold">NSIA ASSURANCE 👋</h4>
            <p class="mb-4 text-center">Veuillez vous connecter pour continuer</p>

                    <form class="mb-3" @submit.prevent="authAdmin()">
                            <div class="form-floating form-floating-outline mb-3">
                                <input type="text" class="form-control" id="email" name="email-username"
                                    v-model="credential.email"
                                    placeholder="Enter your email or username" autofocus />
                                <label for="email">Adresse e-mail</label>
                            </div>
                            <div class="mb-3">
                                <div class="form-password-toggle">
                                    <div class="input-group input-group-merge">
                                        <div class="form-floating form-floating-outline">
                                            <input :type=" showPassword ? 'password' : 'text' " id="password" class="form-control"
                                                name="password" v-model="credential.password"
                                                placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                                                aria-describedby="password" />
                                            <label for="password">Mot de passe</label>
                                        </div>
                                        <span class="input-group-text cursor-pointer" @click="seePassword">
                                            <i :class=" showPassword ? 'mdi mdi-eye-off-outline' : 'mdi mdi-eye-outline' "></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3 d-flex justify-content-between">
                            
                                <!-- <router-link to="/forgot-password" class="float-end mb-1">
                                    <span>Mot de passe oublié ?</span>
                                </router-link> -->
                            </div>
                            <div class="mb-3">
                                <button class="btn btn-primary d-grid w-100" v-if="button">
                                    Se connecter
                                </button>
                                <button class="btn btn-primary d-grid w-100" type="button" v-if="loading" disabled>
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							        <span class="">Chargemment...</span>
                                </button>
                            </div>
                        </form>

            
          </div>
        </div>
        <!-- /Login -->
      </div>
    </div>

</template>

<script>

    // Import the CSS or use your own!
    import "vue-toastification/dist/index.css";
    import { useToast } from "vue-toastification";
    const toast = useToast();
    import { mapActions } from "vuex";
    import axios from 'axios';
    import { apiUrl } from "@/constants/config";

    export default {
        name: 'LoginView',
        data(){
            return {
                credential : {
                    email : '',
                    password : '',
                },
                loading : false,
                button : true,
                showPassword: true
            }
        },
        components: {
            
        },
        mounted(){
            // toast.error("Une erreur s'est produite pendant l'envoie de votre message")
        },
        methods:{

            ...mapActions(["login"]),

            async authAdmin()
            {

                if (
                    this.credential.email == "" ||
                    this.credential.password == ""
                )
                {
                    toast.info("Les deux champs sont obligatoires !")
                    return false;
                }


                this.loading = true;
                this.button = false;
                try
                {
                    const data = new FormData()
                    data.append('email', this.credential.email)
                    data.append('password', this.credential.password)
                    const datas = await axios.post(apiUrl +'/admin/login', data)

                    toast.success(datas.data.message)
                    console.log(datas.data);

                    // await this.$store.commit('setToken', datas.data.token)
                    await this.$store.commit('setUser', datas.data.data)
                    
                    await this.$store.restored
                    
                   
                    window.location.href = 'dashboard'
                    // this.$router.push({name : 'dashboard'}) ; 

                } catch(err){

                    // await swal(`Email ou mot de passe invalide`,'', "error")
                    toast.error("Email et/ou mot de passe invalide !")
                    this.loading = false;
                    this.button = true
                }
            },


            seePassword()
            {
                this.showPassword = !this.showPassword ;
            }

        }
    }
</script>

<style scoped>

</style>
